import React from "react";
import { Icon } from "../../../components/Icon/Icon";
import useStyles from "./styles";
import { colors } from "../../../styles/colors";

interface ActionsTableProps {
  handleEditPub: () => void;
  handleDeletePub: () => void;
}

export const ActionsTable: React.FC<ActionsTableProps> = ({
  handleEditPub,
  handleDeletePub,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.divContainer}>
      <Icon
        name="pencil"
        color={colors.darkblack}
        height={"24px"}
        width={"24px"}
        style={{ cursor: "pointer" }}
        onClick={handleEditPub}
      />
      <Icon
        name="trash"
        color={colors.darkblack}
        height={"24px"}
        width={"24px"}
        style={{ cursor: "pointer" }}
        onClick={handleDeletePub}
      />
    </div>
  );
};
